export default {"src":"/_next/static/media/verified.bd18227b.svg","height":18,"width":19};